import { Building2, ChevronsUpDown, Check, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/**
 * Small store-name pill with switcher (when user has 2+ stores).
 * Shows just the store name (read-only) when there's a single store.
 */
export default function StoreSwitcher() {
  const navigate = useNavigate();
  const { team, stores, switchStore } = useAuth();
  const active = team?.store;
  if (!active) return null;

  const multi = stores && stores.length > 1;

  if (!multi) {
    return (
      <div
        data-testid="store-switcher-single"
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-[#EAE7E1] text-xs"
        title={active.name}
      >
        <Building2 size={14} className="text-[#2E4A3B] flex-shrink-0" />
        <span className="font-medium truncate max-w-[160px]">{active.name}</span>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="store-switcher-btn"
          className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-[#EAE7E1] hover:bg-[#F4F1ED] text-xs transition-colors"
        >
          <Building2 size={14} className="text-[#2E4A3B] flex-shrink-0" />
          <span className="font-medium truncate max-w-[160px]">{active.name}</span>
          <ChevronsUpDown size={12} className="text-[#8E918C] flex-shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64 bg-white">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-[#8E918C]">
          I miei negozi
        </DropdownMenuLabel>
        {stores.map((s) => (
          <DropdownMenuItem
            key={s.id}
            data-testid={`store-switch-${s.id}`}
            onClick={() => s.id !== active.id && switchStore(s.id)}
            className="cursor-pointer flex items-start gap-2"
          >
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{s.name}</div>
              <div className="text-[10px] text-[#8E918C] capitalize">{s.role}</div>
            </div>
            {s.id === active.id && <Check size={14} className="text-[#2B5A3F] mt-0.5" />}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          data-testid="store-switcher-join"
          onClick={() => navigate("/app/team/join")}
          className="cursor-pointer"
        >
          <Plus size={14} className="mr-2 text-[#2E4A3B]" />
          Unisciti a un negozio
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
